<template>
  <div class="login-page">
    <!-- <div style="position: absolute; top: 20px; right: 20px; z-index: 1">
      <a-dropdown overlayClassName="ant-deep-dropdown">
        <span class="drop-down" style="padding: 0 12px; font-size: 20px; color: white">
          <a-icon type="global" style="" />
        </span>
        <a-menu class="menu-item" mode="inline" slot="overlay" @click="changeLanguage">
          <a-menu-item key="zh">
            <span>🇨🇳 简体中文</span>
          </a-menu-item>
          <a-menu-item key="en">
            <span>🇺🇸 English</span>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div> -->
    <div class="login-content" v-if="loginType === 'login'">
      <div class="header-logo">
        <img :src="logo" class="logo" alt="logo" />
      </div>
      <div class="form-login">
        <!-- <div class="login-title">登录</div> -->
        <LoginTab />
        <userAgreement></userAgreement>
        <div class="other-box">
          <a-divider class="dividerClass" orientation="center">{{ $t('base.otherLogin') }}</a-divider>

          <div class="other-btn">
            <!-- <div class="login-form-scan-wx" @click="changeLoginWx()"></div> -->
            <div class="login-form-scan-jjt" @click="changeLoginJJT()"></div>
          </div>
        </div>
      </div>
    </div>
    <a-modal
      width="352px"
      :footer="false"
      :bodyStyle="{ background: '#ffffff', height: '490px' }"
      centered
      title=""
      v-model="captchaModalWx"
    >
      <ScanWx v-if="captchaModalWx" @changeClose="changeCloseWx" />
    </a-modal>
    <a-modal
      width="352px"
      :footer="false"
      :bodyStyle="{ background: '#1C2124', height: '435px' }"
      :closable="false"
      centered
      title=""
      v-model="captchaModal"
    >
      <ScanCode v-if="captchaModal" @changeClose="changeClose" />
    </a-modal>
  </div>
</template>

<script>
import config from '@/config/defaultSettings'
import LoginTab from './components/Login-tab.vue'
import ScanCode from './components/scan-code.vue'
import ScanWx from './components/wx-code.vue'
import userAgreement from '@/components/userAgreement/index.vue'
import { requestComToken } from '@/utils/comToken'
import { getToken, setToken } from '@/utils/auth'
export default {
  name: 'Login',
  components: {
    LoginTab,
    userAgreement,
    ScanCode,
    ScanWx,
  },
  computed: {
    loginConfig() {
      return this.$store.getters.loginConfig
    },
    loginType() {
      return this.$store.getters.LoginInfo.loginType
    },
  },
  data() {
    return {
      logo: config.logoW,
      captchaModalWx: false,
      captchaModal: false,
    }
  },
  mounted() {
  },
  methods: {
    // 切换语言
    changeLanguage({ key }) {
      this.$store.dispatch('setLang', key)
    },
    // 打开微信登录
    changeLoginWx() {
      this.captchaModalWx = true
    },

    // 打开交建通登录
    changeLoginJJT() {
      this.captchaModal = true
    },

    // 关闭弹窗
    changeCloseWx() {
      this.captchaModalWx = false
    },

    // 关闭弹窗
    changeClose() {
      this.captchaModal = false
    },

    // 去注册
    skipToRegisterPage() {
      this.$router.push({
        path: '/register',
      })
    },
  },
}
</script>

<style lang="less" scoped>
.login-page {
  width: 100%;
  height: 100vh;
  background-image: url('../../assets/images/login-bg.png');
  background-size: cover;
  background-repeat: no-repeat;

  .login-content {
    width: 500px;
    height: 100%;
    background-color: #050505;
    opacity: 0.9;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .login-title {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 28px;
    color: #ffffff;
    line-height: 33px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-bottom: 25px;
  }
  .header-logo {
    position: relative;
    left: 67px;
    top: 30px;
    width: 100%;
    // height: @headerHeight;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    //padding: 0px 50px;
    .logo {
      width: 136px;
      height: 22px;
      transform: scale(1.3);
      transform-origin: left;
    }
  }

  .form-login {
    position: relative;
    left: 67px;
    top: 200px;
    width: calc(100% - 67px);
  }
}

.drag {
  -webkit-app-region: drag;
}

.other-box {
  width: 360px;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 12px;
  color: #a2a5ae;
  .dividerClass {
    color: #a2a5ae;
    &::before {
      border-top: 1px solid #32363d;
    }
    &::after {
      border-top: 1px solid #32363d;
    }
  }
  .other-btn {
    margin-top: 10px;
    display: flex;
  }
}

.login-form-scan-wx {
  width: 32px;
  height: 32px;
  background-image: url('../../assets/images/wx-login.png');
  background-size: 100% 100%;
  cursor: pointer;
  margin-left: 16px;
}

.login-form-scan-jjt {
  width: 32px;
  height: 32px;
  margin-left: 16px;
  background-image: url('../../assets/images/jjt-login.png');
  background-size: 100% 100%;
  cursor: pointer;
}

:deep(.ant-divider-inner-text) {
  padding: 0 5px;
}

:deep(.arco-checkbox-label) {
  font-size: 16px;
}

:deep(.arco-checkbox-icon) {
  width: 12px;
  height: 12px;
  border: 1px solid #fff;
}

.forgetPasswordBack {
  height: 60px;
  display: flex;
  align-items: center;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  cursor: pointer;

  > span {
    margin-left: 6px;
  }
}

:deep(.arco-icon-left) {
  width: 26px;
  height: 26px;
  margin-top: 2px;
}
</style>
